 <footer class="footer">
  <div class="container">
    <div class="d-flex justify-content-center">
	    <small class="text-muted">TransForma LLC 2018 V1.85</small>
	    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
	    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
	     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
	      <small *ngIf="isForm"><a href="mailto:admin@transforma.us" class="text-muted">Contact TransForma at admin@transforma.us</a></small>	      
	      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
	      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
	      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
	   <small *ngIf="isForm" class
	   ="text-muted"><a href="javascript:void(0)" class="text-muted" data-toggle="modal" data-target="#unsubscribe">Unsubscribe</a></small>
	   <small *ngIf="!isForm"><a href="mailto:admin@transforma.us" class="text-muted">Contact TransForma at admin@transforma.us</a></small>	   
	 </div>
  </div>
</footer>
<img src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" class="h-hidden" onload="onLoadDocument();">